import React, { useEffect, useState } from "react";
import { StatsMutation } from "../common/home/Stats";
import new1 from "../../assets/images/icon_mutation/old2.svg";
import lunas from "../../assets/images/icon_mutation/lunas.svg";
import done from "../../assets/images/icon_mutation/done.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import { getMutation, getMutationOlder } from "../../core/service/api_mutation";
import moment from "moment";
import { formatCurrency } from "../../config/global";
import arrowright from "../../assets/images/icon_mutation/arrowright.svg";
import arrowleft from "../../assets/images/icon_mutation/arrowleft.svg";
import { includes, max } from "lodash";
import { Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import donation from "../../assets/images/icon_mutation/donation.svg";
import invoice from "../../assets/images/icon_mutation/paper.svg";
import topup from "../../assets/images/icon_mutation/topup.svg";
import card from "../../assets/images/icon_mutation/card.svg";
import admintopup from "../../assets/images/icon_mutation/admin_topup.svg";
import adminbank from "../../assets/images/icon_mutation/admin_bank.svg";
import cashout from "../../assets/images/icon_mutation/cashout.svg";
import transaksi from "../../assets/images/icon_mutation/transfer.svg";
import saldo from "../../assets/images/icon_mutation/saldouser.svg";
import setoran from "../../assets/images/icon_mutation/setoran.svg";
import CustomApp from "../../core/models/customApp";
import { useAppSelector } from "../../core/feature/hooks";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentMutation = () => {
  const is3Month = true;
  let btnMonth: any;
  let btnYear: any;
  let currentDate: any;
  let minDate2: any;
  let maxDate2: any;
  let monthYear: any;
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [mutations, setMutations] = useState<any>([]);
  const [mutationsOlder, setMutationsOlder] = useState<any>([]);
  const dispatch = useDispatch();
  const [sizeA, setSizeA] = useState(10);
  const [pageA, setPageA] = useState(0);
  const [totalA, setTotalA] = useState(0);
  const [sizeB, setSizeB] = useState(10);
  const [pageB, setPageB] = useState(0);
  const [totalB, setTotalB] = useState(0);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<any>(
    moment().startOf("month").format("DD-MM-YYYY")
  );
  const [endDate, setEndDate] = useState<any>(
    moment().endOf("month").format("DD-MM-YYYY")
  );
  const [toDateOlder, setToDateOlder] = useState(
    moment().subtract(90, "days").format("DD-MM-YYYY")
  );
  const [fromDate, setFromDate] = useState<any>(
    moment().subtract(90, "days").format("DD-MM-YYYY")
  );
  const [fromDateOlder, setFromDateOlder] = useState<any>(
    moment().subtract(2, "year").format("DD-MM-YYYY")
  );
  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState<any>({});
  const [mut, setMut] = useState(true);
  const { t } = useTranslation();
  const [icon, setIcon] = useState<any>([]);
  const [monthOption, setMonthOption] = useState<any>([]);
  const [yearOption, setYearOption] = useState<any>([]);
  const year = new Date().getFullYear().toString();
  const [selectedYear, setSelectedYear] = useState(year);
  let month = "";
  month = String(Number(moment().format("MM")));
  month = month.length == 2 ? month : "0" + month;
  const currentMonth = moment().format("MM");
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  currentDate = moment().subtract(89, "days").format("YYYY-MM-DD");
  minDate2 = "2020-01-01";
  maxDate2 = moment().subtract(90, "days").format("MM");
  var january = t("OTHER.month.january");
  var february = t("OTHER.month.february");
  var march = t("OTHER.month.march");
  var april = t("OTHER.month.april");
  var may = t("OTHER.month.may");
  var june = t("OTHER.month.june");
  var july = t("OTHER.month.july");
  var august = t("OTHER.month.august");
  var september = t("OTHER.month.september");
  var october = t("OTHER.month.october");
  var november = t("OTHER.month.november");
  var december = t("OTHER.month.december");
  var yearArray: any = [];
  var monthArray = [
    { value: "01", label: january },
    { value: "02", label: february },
    { value: "03", label: march },
    { value: "04", label: april },
    { value: "05", label: may },
    { value: "06", label: june },
    { value: "07", label: july },
    { value: "08", label: august },
    { value: "09", label: september },
    { value: "10", label: october },
    { value: "11", label: november },
    { value: "12", label: december },
  ];

  useEffect(() => {
    setIs3Month();
    getMutations();
  }, []);

  const getMutations = async () => {
    dispatch(setLoading(true));
    getMutation(fromDate, endDate, pageA, sizeA)
      .then((res: any) => {
        console.log(res.data);
        setMutations(res.data.content);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changePageA = (newPage: any) => {
    setPageA(newPage);
    dispatch(setLoading(true));
    getMutation(fromDate, endDate, newPage, sizeA)
      .then((res: any) => {
        console.log(res.data);
        setMutations(res.data.content);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changeSizeA = (newSize: any) => {
    setSizeA(newSize);
    dispatch(setLoading(true));
    getMutation(fromDate, endDate, 0, newSize)
      .then((res: any) => {
        console.log(res.data);
        setTotalA(res.data.totalElements);
        setMutations(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const detailInvoice = async (item: any) => {
    setShowDetail(true);
    var a = JSON.stringify(item.tags);
    var b = a.split(",");
    var c = b[0].slice(1);
    setDetail(item);
    setIcon(c);
    console.log(c, "detail");
  };

  const mutasi = async () => {
    setMut(true);
    dispatch(setLoading(true));
    setFromDate(moment().subtract(89, "days").format("DD-MM-YYYY"));
    setEndDate(moment().format("DD-MM-YYYY"));
    getMutation(fromDate, endDate, pageA, sizeA)
      .then((res: any) => {
        console.log(res.data);
        setMutations(res.data.content);
        setTotalA(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const mutasiLama = async () => {
    setMut(false);
    dispatch(setLoading(true));
    setFromDate(moment().subtract(89, "days").format("DD-MM-YYYY"));
    setEndDate(moment().format("DD-MM-YYYY"));
    getMutationOlder(startDate, endDate, 0, sizeB)
      .then((res: any) => {
        console.log(res.data);
        setMutationsOlder(res.data.content);
        setTotalB(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changePageB = (newPage: any) => {
    setPageB(newPage);
    dispatch(setLoading(true));
    getMutationOlder(startDate, endDate, newPage, sizeB)
      .then((res: any) => {
        console.log(res.data);
        setMutationsOlder(res.data.content);
        setTotalB(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changeSizeB = (newSize: any) => {
    setSizeB(newSize);
    dispatch(setLoading(true));
    getMutationOlder(fromDateOlder, toDateOlder, 0, newSize)
      .then((res: any) => {
        console.log(res.data);
        setTotalB(res.data.totalElements);
        setMutationsOlder(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const setIs3Month = async () => {
    // currentDate = moment().format("MM");
    let result = [];
    // for (let i = currentDate - 1; i > currentDate - 5; i--) {
    //   result.push(monthArray[(monthArray.length + i) % monthArray.length]);
    // }
    currentDate = new Date().getMonth(); // Current month (0-based index)
    const maxMonthIndex = Math.max(0, currentDate - 3);
    setMonthOption(monthArray.slice(0, maxMonthIndex + 1));
    var tempYear = parseInt(year);
    for (var i = 0; i < 3; i++) {
      var tempYear = parseInt(year) - i;
      yearArray.push({ value: `${tempYear}`, label: `${tempYear}` });
    }
    setYearOption(yearArray);
  };

  const handleChangeMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newMonth = event.target.value;
    console.log(newMonth);

    setSelectedMonth(newMonth);

    if (selectedYear) {
      calculateStartAndEndDates(selectedYear, newMonth);
    }
  };

  const handleChangeYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newYear = event.target.value;
    console.log(newYear);

    setSelectedYear(newYear);

    if (selectedMonth) {
      calculateStartAndEndDates(newYear, selectedMonth);
    }
  };

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      calculateStartAndEndDates(selectedYear, selectedMonth);
    }
  }, [selectedMonth, selectedYear]);

  const calculateStartAndEndDates = (year: string, month: string) => {
    const startDate = moment(`${year}-${month}-01`).format("DD-MM-YYYY");
    const endDate = moment(`${year}-${month}-01`)
      .endOf("month")
      .format("DD-MM-YYYY");

    setStartDate(startDate);
    setEndDate(endDate);

    mutasiLama();
    // getMutationsOlders();
  };

  return (
    <div className="font-montserrat bg-psp-primary pb-20">
      <StatsMutation />
      <div className="w-full">
        <div className="mx-auto w-full container md:-mt-30 -mt-20 p-4 relative justify-between items-left bg-white shadow rounded-2xl">
          <div className="flex">
            <BackButton />
            <div className="font-bold text-4xl">
              {t("TOPUP.balance") + " " + t("MUTATION.title")}
            </div>
          </div>
          <div className="p-4">
            <button
              onClick={() => mutasi()}
              style={
                mut
                  ? {
                      backgroundColor: customApp.app_accent_color,
                      color: isDarkColor(customApp.app_accent_color)
                        ? "white"
                        : "black",
                    }
                  : { backgroundColor: "white" }
              }
              className={`py-2 text-slate-400 rounded-xl border px-3 focus:text-white mr-3`}
            >
              {t("MUTATION.3Month")}
            </button>
            <button
              onClick={() => mutasiLama()}
              style={
                !mut
                  ? {
                      backgroundColor: customApp.app_accent_color,
                      color: isDarkColor(customApp.app_accent_color)
                        ? "white"
                        : "black",
                    }
                  : { backgroundColor: "white" }
              }
              className={`py-2 text-slate-400 rounded-xl border px-3 focus:text-white mr-3`}
            >
              {t("MUTATION.30Older")}
            </button>
            {/* <button className="relative float-right bg-[#D654EB] py-2 w-[150px] rounded-xl text-white hover:bg-[#9d41ab]">
              Download
            </button> */}
          </div>
          <div>
            <p className="text-2xl pl-3 text-slate-400 mb-6">
              {t("INVOICE.history")}
            </p>
          </div>
          {mut === true ? (
            <div className="relative p-3">
              <div className="relative">
                {mutations.length < 1 ? (
                  <div className="text-center">{t("OTHER.dataNotFound")}</div>
                ) : (
                  <div>
                    {mutations.map((item: any, i: any) => {
                      var a = JSON.stringify(item.tags);
                      var b = a.split(",");
                      var c = b[0].slice(1);
                      console.log(c, "cekk");
                      return (
                        <div>
                          <div
                            key={i}
                            className="justify-end flex bg-white rounded-2xl shadow mb-3 mx-auto"
                          >
                            <div className="flex rounded-2xl flex-row w-full bg-white">
                              <div className="my-8 mx-4">
                                {item.tags.includes("donation") ? (
                                  <img
                                    src={donation}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "invoice" ? (
                                  <img
                                    src={invoice}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "topup" ? (
                                  <img
                                    src={topup}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : item.tags?.includes("card") ? (
                                  <img src={card} alt="" className="w-14"></img>
                                ) : c === "cashout" ? (
                                  <img
                                    src={cashout}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "admin bank" ? (
                                  <img
                                    src={adminbank}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "admin topup" ? (
                                  <img
                                    src={admintopup}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "withdraw cash" ? (
                                  <img
                                    src={cashout}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "transaksi" ? (
                                  <img
                                    src={transaksi}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "setoran" ? (
                                  <img
                                    src={setoran}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : c === "transfer" ? (
                                  <img
                                    src={saldo}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : item.tags.includes("reverse") ? (
                                  <img
                                    src={topup}
                                    alt=""
                                    className="w-14"
                                  ></img>
                                ) : null}
                              </div>
                              <div className="mt-4 text-[1vw]">
                                <p>
                                  {moment(item.dateTime).format(
                                    "DD / MM / YYYY, HH:mm "
                                  )}{" "}
                                  <br />{" "}
                                  <span className="font-bold mr-4">
                                    {item.transactionName}
                                  </span>{" "}
                                  <br />
                                  <span className="text-[0.8vw] text-slate-500">
                                    {item.callerName === ""
                                      ? "-"
                                      : item.callerName}
                                  </span>{" "}
                                  {item.note != "" && (
                                    <div>
                                      <span className="text-[0.8vw] text-slate-500">
                                        {item.note}
                                      </span>
                                    </div>
                                  )}
                                </p>
                              </div>
                              <div>
                                <div className="flex absolute right-3 mt-3">
                                  <div className="flex flex-col text-end mt-3 mr-4">
                                    <span>Nominal</span>
                                    <span
                                      className={`text-[1.2vw] font-bold ${
                                        c === "topup"
                                          ? "text-[#48B699]"
                                          : c === "setoran"
                                          ? "text-[#48B699]"
                                          : c === "transfer"
                                          ? "text-[#48B699]"
                                          : item.tags?.includes("reverse")
                                          ? "text-[#48B699]"
                                          : "text-red"
                                      }`}
                                    >
                                      {c === "topup"
                                        ? formatCurrency(item.credit)
                                        : c === "setoran"
                                        ? formatCurrency(item.credit)
                                        : c === "transfer"
                                        ? formatCurrency(item.credit)
                                        : item.tags?.includes("reverse")
                                        ? formatCurrency(item.credit)
                                        : formatCurrency(item.debit)}
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => detailInvoice(item)}
                                    style={{
                                      backgroundColor:
                                        customApp.app_accent_color,
                                    }}
                                    className={`relative float-right py-2 w-[150px] rounded-xl ${
                                      isDarkColor(customApp.app_accent_color)
                                        ? "text-white"
                                        : "text-black"
                                    } mr-2 mt-4 font-semibold hover:bg-blue-800 hover:shadow-md transition`}
                                  >
                                    Detail
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="flex relative mt-10 justify-between">
                  <div className="pt-2 w-1/4">
                    <p>
                      {t("OTHER.showing")} {pageA + 1} {t("OTHER.to")} {sizeA}{" "}
                      {t("OTHER.from")} {totalA} data
                    </p>
                  </div>
                  <div className="w-auto">
                    <div className="">
                      <select
                        onChange={(value) => {
                          changeSizeA(value.target.value);
                        }}
                        value={sizeA}
                        className="py-2 border rounded-lg bg-white"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={1000}>1000</option>
                      </select>
                      <span className="ml-1">{t("TRANSACTION.page")}</span>
                    </div>
                  </div>
                  <div className="flex w-1/4">
                    <button
                      onClick={() => changePageA(pageA - 1)}
                      disabled={pageA === 0}
                      className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                    >
                      {t("OTHER.previous")}
                    </button>
                    <button
                      onClick={() => changePageA(pageA + 1)}
                      disabled={(pageA + 1) * sizeA > totalA}
                      className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                    >
                      {t("OTHER.next")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="relative p-3">
              <div className="flex flex-row gap-2 w-full mb-4">
                <select
                  className="grow text-black bg-slate-200 font-normal text-sm rounded-lg h-10 w-fit"
                  value={selectedMonth}
                  onChange={handleChangeMonth}
                >
                  {monthOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
                <select
                  className="grow text-black bg-slate-200 font-normal text-sm font-medium rounded-lg h-10 w-fit"
                  value={selectedYear}
                  onChange={handleChangeYear}
                >
                  {yearOption.map((option: any) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="relative">
                {mutationsOlder.length < 1 ? (
                  <div className="text-center">{t("OTHER.dataNotFound")}</div>
                ) : (
                  <div>
                    {mutationsOlder.map((item: any, i: any) => {
                      var a = JSON.stringify(item.tags);
                      var b = a.split(",");
                      var c = b[0].slice(1);
                      console.log(c, "cekk");
                      return (
                        <div>
                          <div
                            key={i}
                            className="justify-end flex bg-[#00A29C] rounded-3xl shadow mb-3 mx-auto"
                          >
                            <div className="flex rounded-2xl flex-row w-full bg-white">
                              <div>
                                <div className="my-8 mx-4">
                                  {item.tags.includes("donation") ? (
                                    <img
                                      src={donation}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "invoice" ? (
                                    <img
                                      src={invoice}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "topup" ? (
                                    <img
                                      src={topup}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : item.tags?.includes("card") ? (
                                    <img
                                      src={card}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "cashout" ? (
                                    <img
                                      src={cashout}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "admin bank" ? (
                                    <img
                                      src={adminbank}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "admin topup" ? (
                                    <img
                                      src={admintopup}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "withdraw cash" ? (
                                    <img
                                      src={cashout}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "transaksi" ? (
                                    <img
                                      src={transaksi}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "setoran" ? (
                                    <img
                                      src={setoran}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : c === "transfer" ? (
                                    <img
                                      src={saldo}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : item.tags.includes("reverse") ? (
                                    <img
                                      src={topup}
                                      alt=""
                                      className="w-14"
                                    ></img>
                                  ) : null}
                                </div>
                              </div>
                              <div className="mt-3 text-[1vw] ml-4">
                                <p>
                                  {moment(item.dateTime).format(
                                    "DD / MM / YYYY, H:mm "
                                  )}{" "}
                                  <br />{" "}
                                  <span className="font-bold mr-4">
                                    {item.transactionName}
                                  </span>{" "}
                                  <br />
                                  <span className="text-[0.8vw] text-slate-500">
                                    {item.callerName === ""
                                      ? ""
                                      : item.callerName}
                                  </span>{" "}
                                </p>
                              </div>
                              <div>
                                <div className="flex absolute right-3 mt-3">
                                  <div className="flex flex-col text-end mt-3 mr-4">
                                    <span>Nominal</span>
                                    <span
                                      className={`text-[1.2vw] font-bold ${
                                        c === "topup"
                                          ? "text-[#48B699]"
                                          : c === "setoran"
                                          ? "text-[#48B699]"
                                          : c === "transfer"
                                          ? "text-[#48B699]"
                                          : item.tags?.includes("reverse")
                                          ? "text-[#48B699]"
                                          : "text-red"
                                      } `}
                                    >
                                      {c === "topup"
                                        ? formatCurrency(item.credit)
                                        : c === "setoran"
                                        ? formatCurrency(item.credit)
                                        : c === "transfer"
                                        ? formatCurrency(item.credit)
                                        : item.tags?.includes("reverse")
                                        ? formatCurrency(item.credit)
                                        : formatCurrency(item.debit)}
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => detailInvoice(item)}
                                    style={{
                                      backgroundColor:
                                        customApp.app_accent_color,
                                    }}
                                    className={`relative float-right bg-blue-700 py-2 w-[150px] rounded-xl ${
                                      isDarkColor(customApp.app_accent_color)
                                        ? "text-white"
                                        : "text-black"
                                    } mr-2 mt-4 font-semibold hover:bg-blue-800 hover:shadow-md transition`}
                                  >
                                    Detail
                                  </button>
                                  {/* <button className="relative float-right bg-[#D654EB] py-2 w-[150px] rounded-xl text-white mt-4 font-semibold hover:bg-[#9d41ab] hover:shadow-md transition">
                                  Download
                                </button> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="flex relative mt-10 justify-between">
                  <div className="pt-2 w-1/4">
                    <p>
                      {t("OTHER.showing")} {pageB + 1} {t("OTHER.to")} {sizeB}{" "}
                      {t("OTHER.from")} {totalB} data
                    </p>
                  </div>
                  <div className="w-auto">
                    <div className="">
                      <select
                        onChange={(value) => {
                          changeSizeB(value.target.value);
                        }}
                        value={sizeB}
                        className="py-2 border rounded-lg bg-white"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={1000}>1000</option>
                      </select>
                      <span className="ml-1">{t("TRANSACTION.page")}</span>
                    </div>
                  </div>
                  <div className="flex w-1/4">
                    <button
                      onClick={() => changePageB(pageB - 1)}
                      disabled={pageB === 0}
                      className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                    >
                      {t("OTHER.previous")}
                    </button>
                    <button
                      onClick={() => changePageB(pageB + 1)}
                      disabled={(pageB + 1) * sizeB > totalB}
                      className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                    >
                      {t("OTHER.next")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <Transition
          show={showDetail}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div className="flex flex-col">
                      <div className="w-full">
                        {detail.tags?.includes("donation") ? (
                          <img
                            src={donation}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "invoice" ? (
                          <img
                            src={invoice}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "topup" ? (
                          <img
                            src={topup}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : detail.tags?.includes("card") ? (
                          <img src={card} alt="" className="w-14 mx-auto"></img>
                        ) : icon === "cashout" ? (
                          <img
                            src={cashout}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "admin bank" ? (
                          <img
                            src={adminbank}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "admin topup" ? (
                          <img
                            src={admintopup}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "withdraw cash" ? (
                          <img
                            src={cashout}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "transaksi" ? (
                          <img
                            src={transaksi}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "setoran" ? (
                          <img
                            src={setoran}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : icon === "transfer" ? (
                          <img
                            src={saldo}
                            alt=""
                            className="w-14 mx-auto"
                          ></img>
                        ) : null}
                      </div>
                      <div className="text-center">
                        <p className="text-2xl font-bold mt-4">
                          {t("MUTATION.success")}
                        </p>
                        <span>
                          {t("MUTATION.date") +
                            " " +
                            moment(detail.dateTime).format("DD MMMM YYYY")}
                        </span>
                        <br />
                        <span>{moment(detail.dateTime).format("HH : mm")}</span>
                      </div>
                    </div>
                    <div>
                      <div className="flex flex-row">
                        <div className="mt-3 mr-10">
                          <p className="font-bold">{t("MUTATION.payment")}</p>
                          <p>{t("MUTATION.name")}</p>
                          <p>{t("MUTATION.siswa")}</p>
                          <div className="mt-4">
                            <p className="font-bold">{t("MUTATION.detail")}</p>
                            <p>{t("MUTATION.invoiceName")}</p>
                            {detail?.note != "" && <p>{t("MUTATION.note")}</p>}
                            <p>
                              {icon === "topup"
                                ? t("INVOICE.credit")
                                : detail.tags?.includes("reverse")
                                ? t("INVOICE.credit")
                                : icon === "transfer"
                                ? t("INVOICE.credit")
                                : icon === "setoran"
                                ? t("INVOICE.credit")
                                : "Debit"}{" "}
                            </p>
                            <p>{t("MUTATION.payment")}</p>
                            <p className="font-bold">Nominal</p>
                          </div>
                        </div>
                        <div className="mt-3 text-right">
                          <p className="text-white">Data Pembayaran</p>
                          <p>{detail.accountName}</p>
                          <p>
                            {detail.callerName === "" ? "-" : detail.callerName}
                          </p>
                          <div className="mt-4">
                            <p className="text-white">Detail Transaksi</p>
                            <p>{detail.transactionName}</p>
                            {detail?.note != "" && <p>{detail?.note}</p>}
                            <p>
                              {icon === "topup"
                                ? formatCurrency(detail.credit)
                                : detail.tags?.includes("reverse")
                                ? formatCurrency(detail.credit)
                                : icon === "transfer"
                                ? formatCurrency(detail.credit)
                                : icon === "setoran"
                                ? formatCurrency(detail.credit)
                                : formatCurrency(detail.debit)}
                            </p>
                            <div>
                              <p>
                                {detail.status === "SUCCESS"
                                  ? t("OTHER.success")
                                  : t("OTHER.fail")}
                              </p>

                              <p>
                                {icon === "topup"
                                  ? formatCurrency(detail.credit)
                                  : icon === "setoran"
                                  ? formatCurrency(detail.credit)
                                  : icon === "transfer"
                                  ? formatCurrency(detail.credit)
                                  : detail.tags?.includes("reverse")
                                  ? formatCurrency(detail.credit)
                                  : formatCurrency(detail.debit)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        {/* <button
                          onClick={() => setShowDetail(false)}
                          className="w-full rounded-full bg-white border-2 border-blue-600 text-blue-600 boder-bl py-2.5"
                        >
                          Share
                        </button> */}
                        <button
                          onClick={() => setShowDetail(false)}
                          className="w-full text-white bg-red py-2.5 rounded-full mt-3"
                        >
                          {t("OTHER.close")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>
      </div>
    </div>
  );
};

export default ComponentMutation;
